module.exports = __webpack_public_path__ + "img/zedaph-4d941aff-70f5-4042-48a4-08d95b7e528f.png";